export default {
	SELECTION_EXAMEN: 1,
	ETAT_CIVIL: 2
}